<div class="liberar-convite-gratis-dialog">
  <div class="liberar-convite-gratis-dialog__warning">
    ATENÇÃO: a inclusão de convites grátis não pode ser desfeita.
  </div>

  <div class="liberar-convite-gratis-dialog__form">
    <div class="new-form-control-sm liberar-convite-gratis-dialog__field">
      <label for="freeInviteDate">Data</label>
      <p-calendar
        inputId="freeInviteDate"
        name="freeInviteDate"
        [(ngModel)]="date"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        appendTo="body"
      ></p-calendar>
    </div>

    <div class="new-form-control-sm liberar-convite-gratis-dialog__field">
      <label for="freeInviteQty">Nº convites grátis</label>
      <p-inputNumber
        inputId="freeInviteQty"
        name="freeInviteQty"
        [(ngModel)]="qty"
        [min]="1"
        [showButtons]="true"
        [useGrouping]="false"
      ></p-inputNumber>
    </div>
  </div>

  <div class="liberar-convite-gratis-dialog__footer">
    <button type="button" class="new-easymarine disabled" (click)="cancel()">
      Cancelar
    </button>
    <button type="button" class="new-easymarine primary" (click)="confirm()">
      Confirmar
    </button>
  </div>
</div>
